import styles from './MultiPanelModule.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React, { FC, HTMLAttributes } from 'react';

import { MultiPanelModule as MultiPanelModuleType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { FadeToastUp } from 'src/components/Animation/FadeToastUp/FadeToastUp';
import { Grid } from 'src/components/Grid/Grid';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry, flattenContentfulData } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';
import { MultiPanelCell } from './MultiPanelCell';

interface MultiPanelModuleProps extends HTMLAttributes<HTMLDivElement> {
  entry?: FlatEntry<MultiPanelModuleType>;
}

const MultiPanelModule: FC<MultiPanelModuleProps> = ({
  entry,
  style = {},
  className,
  ...props
}) => {
  if (!entry) return null;
  const { backgroundColor, items = [], title, titleColor } = entry;

  const TitleContainer = () => (
    <GridContainer gutter justifyContent="center">
      <Grid item xs={12} md={9} lg={10}>
        <FadeToastUp transitionDuration={1500} threshold={.1}>
          <div>
            <TextV2 isMarkdown value={title} entry={{ ...entry, field: 'title' }} tagName="h2" variant="h2" className={styles.multiplePanelModuleTitle} style={{ color: titleColor }} />
          </div>
        </FadeToastUp>
      </Grid>
    </GridContainer>
  );

  const ItemContainer = () => (
    <GridContainer gutter justifyContent="center" className={styles.multiplePanelModuleCells}>
      <Grid item xs={12} lg={10}>
        <Grid container gutter className={styles.multiplePanelModuleCell}>
          {items.map((item, index) => (
            <Grid key={componentKeyV2(item, index)} item xs={12} md>
              <FadeToastUp transitionDuration={500} key={componentKeyV2(item, index)} delayMultiplier={index + 1}>
                {({ className: cn, ref }) => (
                  <MultiPanelCell entry={item} ref={ref as React.RefObject<HTMLDivElement>} className={cn} />
                )}
              </FadeToastUp>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </GridContainer>
  );

  return (
    <section className={cx(styles.multiplePanelModule, className)} style={{ backgroundColor: backgroundColor || style.backgroundColor }} {...props}>
      {title && <TitleContainer />}
      {items.length && <ItemContainer />}
    </section>
  );
};

MultiPanelModule.displayName = 'MultiPanelModule';

interface MultiPanelModuleWrapperProps extends HTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<MultiPanelModuleType>;
}

const MultiPanelModuleWrapper: FC<MultiPanelModuleWrapperProps> = ({ entry, ...props }) =>
  <MultiPanelModule {...props} entry={flattenContentfulData(entry)} />;

  MultiPanelModuleWrapper.displayName = 'MultiPanelModuleWrapper';

export {
  MultiPanelModule as _MultiPanelModule,
  MultiPanelModuleWrapper as MultiPanelModule,
};
